import React from 'react';
import { ChevronDown } from '@videoblocks/react-icons';
import AnimateHeight from 'react-animate-height';
import { twMerge } from 'tailwind-merge';
export const Accordion = ({
  children,
  chevronSize = 'h-3 w-3',
  title,
  titleStyle = 'font-bold text-xs',
  isOpen,
  onToggle,
  disabled = false,
  buttonStyle = 'text-white w-full flex justify-between items-center'
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    "aria-expanded": isOpen,
    className: twMerge('accordion', buttonStyle),
    onClick: onToggle,
    disabled: disabled
  }, /*#__PURE__*/React.createElement("span", {
    className: titleStyle
  }, title), !disabled && /*#__PURE__*/React.createElement("div", {
    className: twMerge(chevronSize, 'transition-transform ease-in transform flex justify-center items-center', isOpen && 'rotate-180')
  }, /*#__PURE__*/React.createElement(ChevronDown, {
    className: "fill-current w-full"
  }))), /*#__PURE__*/React.createElement(AnimateHeight, {
    duration: 150,
    height: isOpen ? 'auto' : 0
  }, children));
};
export default Accordion;